import {Card, Spinner} from 'react-bootstrap'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'

interface IPeriodData {
  period: string
  periodLabel: string
  policiesCount: number
  cancellationsCount: number
  neverStartedCount: number
}

interface Props {
  periodData: IPeriodData[]
  loading: boolean
}

export const PortfolioGrowthChart = ({periodData, loading}: Props) => {
  const categories = periodData.map((d) => d.periodLabel)

  // Cumulative active portfolio: running sum of net growth per period
  let running = 0
  const portfolioData = periodData.map((d) => {
    const netGrowth = (d.policiesCount ?? 0) - (d.cancellationsCount ?? 0) - (d.neverStartedCount ?? 0)
    running += netGrowth
    return running
  })

  const options: ApexOptions = {
    chart: {
      type: 'area',
      height: 240,
      toolbar: {show: false},
      zoom: {enabled: false},
    },
    stroke: {width: 3, curve: 'smooth'},
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
      },
    },
    markers: {size: 3},
    xaxis: {
      categories,
      labels: {rotate: -45, rotateAlways: false},
    },
    yaxis: {
      labels: {formatter: (v: number) => v.toLocaleString()},
    },
    tooltip: {
      y: {formatter: (v: number) => v.toLocaleString()},
    },
    legend: {show: false},
    colors: ['#1bc5bd'],
    dataLabels: {enabled: false},
  }

  const series = [{name: 'Active Portfolio', data: portfolioData}]

  return (
    <Card className='card-flush'>
      <Card.Header className='border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Portfolio Growth</span>
          <span className='text-muted fw-semibold fs-7'>
            Cumulative active policies — net enrollments accumulated month over month
          </span>
        </h3>
      </Card.Header>
      <Card.Body>
        {loading && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 240}}>
            <Spinner animation='border' />
          </div>
        )}
        {!loading && periodData.length === 0 && (
          <div className='d-flex justify-content-center align-items-center' style={{height: 240}}>
            <p className='text-muted'>No data available for the selected period</p>
          </div>
        )}
        {!loading && periodData.length > 0 && (
          <Chart options={options} series={series} type='area' height={240} />
        )}
      </Card.Body>
    </Card>
  )
}
